// src/pages/ThanksPage.js
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "../../styles/ThanksPage.css";

export default function ThanksPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="thanks-page">
      <div className="thanks-card">
        {/* ロゴ */}
        <div className="thanks-logo">
          <img src="/images/logo_limot.png" alt="Limot logo" />
        </div>

        {/* メッセージ */}
        <h1 className="thanks-title">{t("thanks.title")}</h1>

        {/* 戻るボタン */}
        <button
          onClick={() => navigate("/hamamatsu")}
          className="thanks-button"
        >
          {t("thanks.backHome")}
        </button>
      </div>
    </div>
  );
}
